import { mapModifierGroup } from '@/entities/product/model/mapModifierGroup'
import { resolveProductImageUrl } from '@/entities/product/lib/resolveProductImages'
import { mapProductImagesFromApi } from '@/features/admin-catalog/lib/mapProductImages'

export function mapAdminProductListItem(raw) {
  return {
    id: String(raw.id ?? ''),
    restoId: String(raw.resto_id ?? ''),
    categoryId: raw.category_id != null ? String(raw.category_id) : '',
    categoryTitle: raw.category_title != null ? String(raw.category_title).trim() : '',
    title: String(raw.title ?? ''),
    subtitle: raw.subtitle != null ? String(raw.subtitle) : '',
    imageUrl: resolveProductImageUrl(raw, 'small'),
    price: Number(raw.price) || 0,
    weightG:
      raw.weight_g != null && Number.isFinite(Number(raw.weight_g)) ? Number(raw.weight_g) : null,
    isAvailable: raw.is_available !== false,
    createdAt: raw.created_at ?? null,
    updatedAt: raw.updated_at ?? null,
  }
}

export function mapAdminProduct(raw) {
  const productImages = mapProductImagesFromApi(raw)
  const imageUrls = productImages.map((item) => item.previewUrl).filter(Boolean)

  const modifierGroups = Array.isArray(raw.modifier_groups)
    ? raw.modifier_groups.map(mapModifierGroup).filter((group) => group.id && group.options.length)
    : []

  return {
    id: String(raw.id ?? ''),
    restoId: String(raw.resto_id ?? ''),
    categoryId: raw.category_id != null ? String(raw.category_id) : '',
    categoryTitle: raw.category_title != null ? String(raw.category_title).trim() : '',
    tags: Array.isArray(raw.tags) ? raw.tags.map((tag) => String(tag)) : [],
    title: String(raw.title ?? ''),
    subtitle: raw.subtitle != null ? String(raw.subtitle) : '',
    description: raw.description != null ? String(raw.description) : '',
    price: Number(raw.price) || 0,
    weightG:
      raw.weight_g != null && Number.isFinite(Number(raw.weight_g)) ? Number(raw.weight_g) : null,
    imageUrls,
    productImages,
    isAvailable: raw.is_available !== false,
    modifierGroups,
    createdAt: raw.created_at ?? null,
    updatedAt: raw.updated_at ?? null,
  }
}
